const wordRegexp = /[^:'"?/\s><#&().,]+/gu;

function stripEmailSuffix(str: string): string {
  const splitIndex = str.indexOf('@');
  return splitIndex < 0 ? str : str.slice(0, splitIndex);
}

export default function getUserNameInitials(userDisplayName: string | undefined): string {
  const words = stripEmailSuffix(userDisplayName || '').match(wordRegexp) ?? [];
  const selectedWords = words.length > 2 ? [words.at(0)!, words.at(-1)!] : words;
  return (
    selectedWords
      .map((word) => word.at(0))
      .join('')
      .toLocaleUpperCase() ?? ''
  );
}
